import { render, staticRenderFns } from "./ClientCreateStepOne.vue?vue&type=template&id=9b87ca4a&scoped=true&"
import script from "./ClientCreateStepOne.vue?vue&type=script&lang=js&"
export * from "./ClientCreateStepOne.vue?vue&type=script&lang=js&"
import style0 from "./ClientCreateStepOne.vue?vue&type=style&index=0&id=9b87ca4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b87ca4a",
  null
  
)

export default component.exports